import * as Sentry from '@sentry/react';
import * as serviceWorker from 'serviceWorkerRegistration';
import App from 'App';
import { BrowserTracing } from '@sentry/browser';
import { createRoot } from 'react-dom/client';
import { Helmet } from 'react-helmet';
import { PersistGate } from 'redux-persist/integration/react';
import { Provider } from 'react-redux';
import React from 'react';
import { BrowserRouter as Router } from 'react-router-dom';
import { persistor, store } from './redux/store';

import '@fontsource/fira-sans/100.css';
import '@fontsource/fira-sans/200.css';
import '@fontsource/fira-sans/300.css';
import '@fontsource/fira-sans/400.css';
import '@fontsource/fira-sans/500.css';
import '@fontsource/fira-sans/600.css';
import '@fontsource/fira-sans/700.css';
import '@fontsource/fira-sans/800.css';
import '@fontsource/fira-sans/900.css';

Sentry.init({
  environment: process.env.NODE_ENV,
  dsn: 'https://8b9d9793680e426ab164b4c77f0ea828@o1167188.ingest.sentry.io/6258001',
  integrations: [new BrowserTracing()],

  // Set tracesSampleRate to 1.0 to capture 100%
  // of transactions for performance monitoring.
  // We recommend adjusting this value in production
  tracesSampleRate: 1.0,
});

const container = document.getElementById('root') as HTMLElement;
const root = createRoot(container);

root.render(
  <Router>
    <Helmet
      encodeSpecialCharacters
      titleTemplate="%s [pagcomanda]"
      defaultTitle="pagcomanda - O jeito mais fácil de pagar a conta"
    />
    <Provider store={store}>
      <PersistGate loading={null} persistor={persistor}>
        <App />
      </PersistGate>
    </Provider>
  </Router>,
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA

serviceWorker.register({
  onDownloading: (registration) => {
    window.dispatchEvent(new CustomEvent('serviceworkerdownloading', {
      detail: registration,
    }));
  },
  onUpdate: (registration) => {
    window.dispatchEvent(new CustomEvent('serviceworkerupdate', {
      detail: registration,
    }));
  },
});
